"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureToggleService = void 0;
var LoginApi_1 = require("../api/LoginApi");
var FeatureToggleResponse_1 = require("../models/response/FeatureToggleResponse");
// This is a singleton class which on the first call will load
// the current toggles, and use them for the rest of the session
var FeatureToggleService = /** @class */ (function () {
    function FeatureToggleService() {
        this.loginApi = new LoginApi_1.default();
        // The loaded toggles;
        this.featureToggleResponse = null;
        this.togglesPromise = null;
    }
    // Check if the provided feature toggle, is enabled or disabled
    // returns a promise that will resolve to a boolean true or false flag
    FeatureToggleService.prototype.checkFeatureToggleEnabled = function (toggleName) {
        var _this = this;
        return new Promise(function (resolve) {
            // tslint:disable:no-any
            var failure = function (error) {
                console.log('login-ui:: Feature Toggle Serivce - failure in retrival', error);
                resolve(false);
            };
            // Callback used in 2 places below to handle
            // processing the fetureToggleRsponse for the current toggleName
            var success = function (toggles) {
                if (toggles === null) {
                    resolve(false);
                }
                else {
                    try {
                        var details = new FeatureToggleResponse_1.FeatureToggleDetails(toggles, toggleName);
                        resolve(details.isEnabled);
                    }
                    catch (e) {
                        console.error("login-ui: checkFeatureToggleEnabled - error creating FeatureToggleDetails for " + toggleName);
                        resolve(false);
                    }
                }
            };
            if (_this.featureToggleResponse === null) {
                _this.loadFeatureToggles().then(success, failure);
            }
            else {
                // Call the above call back to keep that code one place
                success(_this.featureToggleResponse);
            }
        });
    };
    // If necessary, this create a new request to retreive the details
    // and stores a promise to it, if that was already created, it
    // simply returns the promise so that call is only run once.
    FeatureToggleService.prototype.loadFeatureToggles = function () {
        var _this = this;
        if (this.togglesPromise === null) {
            this.togglesPromise = new Promise(function (resolve, reject) { return __awaiter(_this, void 0, void 0, function () {
                var result, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, this.loginApi.getFeatureDetails('', 'user-001', false, 'idm')];
                        case 1:
                            result = _a.sent();
                            console.debug('login-ui:: FeatureToggleService - loadFeatureToggles', result);
                            if (result) {
                                this.featureToggleResponse = result;
                            }
                            else {
                                console.error('login-ui::FeatureToggleService - Unknown Error loading feature toggles.');
                            }
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            console.error('login-ui::FeatureToggleService - Error loading feature toggles.', e_1);
                            reject(e_1);
                            return [3 /*break*/, 3];
                        case 3:
                            resolve(this.featureToggleResponse);
                            return [2 /*return*/];
                    }
                });
            }); });
        }
        return this.togglesPromise;
    };
    return FeatureToggleService;
}());
exports.FeatureToggleService = FeatureToggleService;
exports.default = new FeatureToggleService();
//# sourceMappingURL=FeatureToggleService.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/login-ui/services/FeatureToggleService.js
// module id = 273
// module chunks = 8